module.exports = __webpack_public_path__ + "static/media/settings.4b0412c9.svg";